import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=4a530076&scoped=true"
import script from "./FormBody.vue?vue&type=script&lang=js"
export * from "./FormBody.vue?vue&type=script&lang=js"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=4a530076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a530076",
  null
  
)

export default component.exports